import { useCallback } from 'react';

import * as server from './server';

export const useGetDepositLimits = () => {
    return useCallback(async () => {
        const {
            data: {
                currentLimits,
                waitingLimits
            }
        } = await server.getDepositLimits();

        return {
            currentLimits,
            waitingLimits
        };
    }, []);
};
